<template>
  <div class="action-buttons w-full flex justify-between items-start pointer-events-none">
    <el-tooltip placement="top" :offset="15" :open-delay="450">
      <div slot="content">{{ usesThemeStyles ? 'Unlink from theme' : 'Link to theme' }}</div>
      <el-button
          class="!rounded-tl-none !px-1 !py-0.5 !outline-none border-0 hover:text-body-black group pointer-events-all"
          type="info"
          size="mini"
          @click.stop="triggerUpdateThemeLink(contentItemId)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#fefefe" v-if="!usesThemeStyles" v-bind:svg-inline="''" v-bind:class="'icon w-4 focus:outline-none fill-current'" v-bind:src="'./../../../../../public/icons/link.svg'" v-bind:role="'presentation'" v-bind:focusable="'false'"><path d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80zM320-440v-80h320v80H320zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#fefefe" v-else="" v-bind:svg-inline="''" v-bind:class="'icon w-4 focus:outline-none fill-current'" v-bind:src="'./../../../../../public/icons/unlink.svg'" v-bind:alt="''" v-bind:role="'presentation'" v-bind:focusable="'false'"><path d="M770-302l-60-62q40-11 65-42.5t25-73.5q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 57-29.5 105T770-302zM634-440l-80-80h86v80h-6zM792-56L56-792l56-56 736 736-56 56zM440-280H280q-83 0-141.5-58.5T80-480q0-69 42-123t108-71l74 74h-24q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80zM320-440v-80h65l79 80H320z"/></svg>
      </el-button>
    </el-tooltip>


    <div>
      <el-button-group class="action-buttons">
        <el-button
            v-if="!disableClone"
            class="focus:outline-none pointer-events-all"
            type="info"
            icon="el-icon-copy-document"
            size="mini"
            @click.stop="cloneContentItem(contentItemId)"></el-button>
        <el-button
            v-if="!disableDelete"
            class="!rounded-tr-none !outline-none pointer-events-all"
            type="info"
            icon="el-icon-delete"
            size="mini"
            @click.stop="triggerDeleteContentItem(targetWidgetID, targetStepID, contentItemId, contentItemIndex)">
        </el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ActionButtons',
  props: {
    contentItemId: {
      required: true,
      type: String,
    },
    contentItemIndex: {
      required: true,
      type: Number,
    },
    usesThemeStyles: {
      required: false,
      type: Boolean,
      default: false,
    },
    isGlobalContentItem: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableClone: {
      required: false,
      type: Boolean,
      default: false,
    },
    disableDelete: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    targetWidgetID() {
      return this.$store.state.campaign.widget.targetWidgetID
    },
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },
  },
  methods: {
    ...mapActions('campaign/contentItem', [
      'cloneContentItem',
      'deleteContentItem',
      'updateContentItem',
      'updateGlobalContentItem',
    ]),
    triggerDeleteContentItem(
        widgetID, stepID, contentItemID, contentItemIndex) {
      this.deleteContentItem(
          { widgetID, stepID, contentItemID, contentItemIndex })
      // ToDo remove ContentItem from DB (or do it in the store?)
    },
    triggerUpdateThemeLink() {
      if (!this.isGlobalContentItem) {
        // Only update when there's a difference
        this.updateContentItem({
          id: this.contentItemId,
          path: ['settings'],
          attribute: 'usesThemeStyles',
          data: !this.usesThemeStyles,
          skipThemeUnlink: true, // Skip theme unlinking
        })
      } else {
        const type = this.contentItemId === 'wheel'
            ? 'wheel'
            : 'sideImage'

        this.updateGlobalContentItem({
          id: this.contentItemId,
          itemName: [type],
          path: ['settings'],
          attribute: 'usesThemeStyles',
          data: !this.usesThemeStyles,
          skipThemeUnlink: true,
        })
      }
    },
  },
}
</script>